/* eslint-disable */

import axios from 'axios';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useDetectClickOutside } from 'react-detect-click-outside';
import { MdOutlineShoppingCart } from 'react-icons/md';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { colors } from '../../helper/constant/colors';
import { useExpireAlert } from '../../hooks/useExpireAlert';
import { useShopSearch } from '../../hooks/useShopSearch';
import ModalPopupMessage from '../modal/ModalPopupMessage';
import BarcodeScanner from '../scanner/BarcodeScanner';
import Sidebar from '../sidebar/Sidebar';
import MobileSearchOverlay from './MobileSearchOverlay';
import './Navbar.css';

function Navbar(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebar_toggle, setSidebar_toggle] = useState(false);
  const [topbar_selected, setTopbar_selected] = useState(0);
  const [isSticky, setIsSticky] = useState(false);

  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });

  function showDialogCallback_General(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function showDialogCallback_Confirm(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
    navigate('/');
  }

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (location.pathname.search('/home') > -1) {
      setTopbar_selected(1);
    } else if (location.pathname.search('/marketplace') > -1) {
      setTopbar_selected(2);
    } else if (location.pathname.search('/myshop') > -1) {
      setTopbar_selected(3);
    } else if (location.pathname.search('/about') > -1) {
      setTopbar_selected(4);
    } else {
      setTopbar_selected(0);
    }
  }, [location]);

  function welcometext(sname) {
    if (sname !== null) {
      if (props.permitdata.shop_name !== '-' && props.permitdata.shop_name !== undefined) {
        return (
          <Link
            to='/marketplace?category=รวมสินค้า'
            className='font-size-13 u-header-topbar__nav-link font-th'
          >
            ยินดีต้อนรับ {sname.shop_name} เข้าสู่
            <strong className='text-primary'> มียา.com</strong>
          </Link>
        );
      }
    }
    return (
      <Link
        to='/marketplace?category=รวมสินค้า'
        className='font-size-13 u-header-topbar__nav-link font-th'
      >
        ยินดีต้อนรับเข้าสู่<strong className='text-primary'> มียา.com</strong>
      </Link>
    );
  }

  function callback_security(mode) {
    if (mode === 'same') {
      setModal_popup({
        modaltype: 'modal-info',
        headers: 'กรุณาสมัครสมาชิก',
        message:
          'การซื้อขายสินค้าบน แพล๊ตฟอร์ม มียานั้น ผู้ใช้งานจะต้องลงทะเบียนก่อนเริ่มทำการซื้อขาย',
        enable: true,
      });
    } else {
      setModal_popup({
        modaltype: 'modal-signup',
        headers: 'กรุณาสมัครสมาชิก',
        message:
          'การซื้อขายสินค้าบน แพล๊ตฟอร์ม มียานั้น ผู้ใช้งานจะต้องลงทะเบียนก่อนเริ่มทำการซื้อขาย',
        enable: true,
      });
    }
  }
  return (
    <>
      <div
        className={
          'header-placeholder ' + (location.pathname.includes('/passwordreset') ? 'd-none' : '')
        }
      ></div>
      <header
        id='header'
        className={
          'u-header u-header-left-aligned-nav ' +
          (location.pathname.includes('/passwordreset') ? 'd-none' : '')
        }
      >
        <div className='u-header__section '>
          <div className='u-header-topbar py-2 d-none d-xl-block '>
            <div className='container'>
              <div className='d-flex align-items-center'>
                {props.islogin === false && props.permitdata !== null ? (
                  <div className='topbar-right ml-auto'>
                    <ul className='list-inline mb-0'>
                      {props.permitdata.role !== 'guest' &&
                      props.permitdata.token !== '' &&
                      props.permitdata.token !== '-' ? (
                        <li className='list-inline-item mr-0 u-header-topbar__nav-item u-header-topbar__nav-item-border'>
                          <Link
                            className='u-header-topbar__nav-link'
                            to='/'
                            title='ออกจากระบบ'
                            data-toggle='tooltip'
                            data-placement='bottom'
                            onClick={props.callback_signout}
                          >
                            <i className='fas fa-sign-out-alt font-size-18 text-warning'></i>{' '}
                            ออกจากระบบ
                          </Link>
                        </li>
                      ) : (
                        <li className='list-inline-item mr-0 u-header-topbar__nav-item u-header-topbar__nav-item-border'>
                          <Link
                            className='u-header-topbar__nav-link'
                            to='/'
                            title='เข้าสู่ระบบ'
                            data-toggle='tooltip'
                            data-placement='bottom'
                          >
                            <i className='fas fa-sign-in-alt font-size-18 text-warning'></i>
                            ลงทะเบียน / เข้าสู่ระบบ
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                ) : null}
                {props.islogin === true ? (
                  <div className='topbar-right ml-auto d-flex d-md-none'>
                    <div className='font-th mr-4' onClick={props.callback_popup_register}>
                      ลงทะเบียน
                    </div>
                    <div className='font-th' onClick={props.callback_popup_signin}>
                      เข้าสู่ระบบ
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>

          <NavbarMobileShopee
            mycartlen={props.mycartlen}
            permitdata={props.permitdata}
            systemdata_productcategorylist={props.systemdata_productcategorylist}
            callback_sidebar_toggle={(val) => setSidebar_toggle(val)}
            productCatalog={props.productCatalog}
            islogin={props.islogin}
            app_hostname={props.app_hostname}
          />

          <div className='py-0 py-xl-0 d-none d-xl-block'>
            <div className='container my-0dot5 my-xl-0'>
              <div className='row align-items-center border-bottom border-xl-bottom-0'>
                <div className='col-auto'>
                  <nav className='navbar navbar-expand u-header__navbar py-0 justify-content-xl-between max-width-270 min-width-270c py-xl-0 px-0'>
                    <Link
                      className='order-1 order-xl-0 navbar-brand u-header__navbar-brand u-header__navbar-brand-center'
                      to={sessionStorage.getItem('meya-job-loggedin') === 'true' ? '/marketplace?category=สินค้าโปรโมชั่น&&transaction=FNYG18ZWHu' : '/marketplace?category=รวมสินค้า'}
                    >
                      <img
                        className='d-none d-xl-block'
                        src={`${process.env.PUBLIC_URL}/images/Meya-logo1.png`}
                        alt='meya-logo'
                        style={{ height: '60px', width: 'auto' }}
                      />
                      <h6 className='d-none d-sm-block d-xl-none text-dark my-0 font-th font-weight-bold'>
                        มียา.com
                      </h6>
                    </Link>
                    {props.permitdata !== null ? (
                      props.permitdata.role !== 'guest' &&
                      props.permitdata.token !== '' &&
                      props.permitdata.token !== '-' ? (
                        <button
                          id='sidebarHeaderInvokerMenu'
                          type='button'
                          onClick={() => {
                            setSidebar_toggle(true);
                          }}
                          className='navbar-toggler d-block btn u-hamburger mr-3 mr-xl-0'
                        >
                          <span id='hamburgerTriggerMenu' className='u-hamburger__box'>
                            <span className='u-hamburger__inner'></span>
                          </span>
                        </button>
                      ) : null
                    ) : null}
                  </nav>
                </div>
                <div className='d-none d-xl-block'>
                  <NavbarMenu
                    islogin={props.islogin}
                    permitdata={props.permitdata}
                    topbar_selected={topbar_selected}
                    callback_security={(message) => {
                      callback_security(message);
                    }}
                  ></NavbarMenu>
                </div>

                <NavbarSupport
                  islogin={props.islogin}
                  permitdata={props.permitdata}
                  callback_popup_register={props.callback_popup_register}
                  callback_popup_signin={props.callback_popup_signin}
                ></NavbarSupport>
                {props.islogin === false ? (
                  props.permitdata !== null ? (
                    props.permitdata.role !== 'guest' &&
                    props.permitdata.token !== '' &&
                    props.permitdata.token !== '-' ? (
                      <NavbarSearchTablet
                        permitdata={props.permitdata}
                        app_hostname={props.app_hostname}
                        islogin={props.islogin}
                        mycartlen={props.mycartlen}
                        messages_chat_unread={props.messages_chat_unread}
                        myorderlen={props.myorderlen}
                        buyer_category={props.buyer_category}
                        productCatalog={props.productCatalog}
                        seller_products={props.seller_products}
                      ></NavbarSearchTablet>
                    ) : null
                  ) : null
                ) : null}
              </div>
            </div>
          </div>
          {props.islogin === false ? (
            props.permitdata !== null ? (
              props.permitdata.role !== 'guest' &&
              props.permitdata.token !== '' &&
              props.permitdata.token !== '-' ? (
                <div className='d-none d-xl-block'>
                  <NavbarSearch
                    app_hostname={props.app_hostname}
                    permitdata={props.permitdata}
                    islogin={props.islogin}
                    mycartlen={props.mycartlen}
                    messages_chat_unread={props.messages_chat_unread}
                    myorderlen={props.myorderlen}
                    buyer_category={props.buyer_category}
                    productCatalog={props.productCatalog}
                    seller_products={props.seller_products}
                  ></NavbarSearch>
                </div>
              ) : null
            ) : null
          ) : null}
        </div>
      </header>
      <Sidebar
        sidebar_toggle={sidebar_toggle}
        islogin={props.islogin}
        permitdata={props.permitdata}
        systemdata_productcategorylist={props.systemdata_productcategorylist}
        callback_signout={props.callback_signout}
        callback_closebar={(message) => {
          setSidebar_toggle(false);
        }}
      ></Sidebar>
      <ModalPopupMessage
        callback_general={(message) => {
          showDialogCallback_General(message);
        }}
        callback_confirm={(message) => {
          showDialogCallback_Confirm(message);
        }}
        options={modal_popup}
      />
    </>
  );
}

function NavbarMenu(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const { hasExpireAlert } = useExpireAlert(props.permitdata);
  const [navlink, setnavlink] = useState('');

  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });

  useEffect(() => {
    if (navlink !== '') {
      var tmp = navlink;
      setnavlink('');
      navigate(tmp);
    }
  }, [navlink]);

  async function security_protection(mode) {
    if (mode === 'seller' || mode === 'buyer') {
      if (props.permitdata !== null) {
        if (props.permitdata.token === '' || props.permitdata.token === '-') {
          if (location.pathname === '' || location.pathname === '/') {
            props.callback_security('same');
          } else {
            props.callback_security('redirect');
          }
        } else {
          if (mode === 'seller') {
            setnavlink('/myshop/buyer/payment');
          } else {
            setnavlink('/marketplace?category=รวมสินค้า');
          }
        }
      } else {
        if (location.pathname === '' || location.pathname === '/') {
          props.callback_security('same');
        } else {
          props.callback_security('redirect');
        }
      }
    }
  }

  function showDialogCallback_General(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function showDialogCallback_Confirm(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
    navigate('/');
  }

  return (
    <div className='col-auto'>
      <nav className='navbar navbar-expand u-header__navbar u-header__navbar--no-space'>
        <div id='navBar' className='collapse navbar-collapse u-header__navbar-collapse'>
          <ul className='navbar-nav u-header__navbar-nav '>
            <li
              className={
                'nav-item u-header__nav-item ' + (props.topbar_selected === 2 ? 'active' : '')
              }
            >
              <Link
                className='nav-link u-header__nav-link font-th'
                onClick={() => {
                  if (sessionStorage.getItem('meya-job-loggedin') === 'true') {
                    setnavlink('/marketplace?category=สินค้าโปรโมชั่น&&transaction=FNYG18ZWHu');
                  } else {
                    security_protection('buyer');
                  }
                }}
              >
                หน้าแรก
              </Link>
            </li>
            {props.islogin === false && props.permitdata !== null ? (
              (props.permitdata.role !== 'guest' && props.permitdata.token !== '') || sessionStorage.getItem('meya-job-loggedin') === 'true' ? (
                <li
                  className={
                    'nav-item u-header__nav-item ' + (props.topbar_selected === 3 ? 'active' : '')
                  }
                >
                  <Link 
                    className='nav-link u-header__nav-link font-th' 
                    to={sessionStorage.getItem('meya-job-loggedin') === 'true' ? '/marketplace?category=สินค้าโปรโมชั่น&&transaction=FNYG18ZWHu' : '/myshop/buyer/payment'}
                  >
                    {sessionStorage.getItem('meya-job-loggedin') === 'true' ? 'เข้าชมร้านค้า' : 'ร้านค้าของฉัน'}
                    {hasExpireAlert ? (
                      <span className='myshop-alert-icon' aria-hidden='true'>
                        !
                      </span>
                    ) : null}
                  </Link>
                </li>
              ) : null
            ) : null}
            <li
              className={
                'nav-item u-header__nav-item ' + (props.topbar_selected === 4 ? 'active' : '')
              }
            >
              <Link className='nav-link u-header__nav-link font-th' to='/about'>
                เกี่ยวกับเรา
              </Link>
            </li>
            <li className='nav-item u-header__nav-item'>
              <Link className='nav-link u-header__nav-link font-th' to='/jobs'>
                ระบบหางาน
              </Link>
            </li>
          </ul>
        </div>
      </nav>

      <ModalPopupMessage
        callback_general={(message) => {
          showDialogCallback_General(message);
        }}
        callback_confirm={(message) => {
          showDialogCallback_Confirm(message);
        }}
        options={modal_popup}
      />
    </div>
  );
}

function NavbarSupport(props) {
  const navigate = useNavigate();
  const [showUserInfo, setShowUserInfo] = useState(false);
  const [bankInfo, setBankInfo] = useState({ bankname: '-', bankno: '-', bankaccountname: '-' });
  const [bankLoaded, setBankLoaded] = useState(false);
  const userInfoRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (userInfoRef.current && !userInfoRef.current.contains(event.target)) {
        setShowUserInfo(false);
      }
    }
    if (showUserInfo) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showUserInfo]);

  useEffect(() => {
    if (
      showUserInfo &&
      !bankLoaded &&
      props.permitdata &&
      props.permitdata.shop_id &&
      props.permitdata.shop_id !== '-'
    ) {
      const formData = new FormData();
      formData.append('shop_seller', props.permitdata.shop_id);
      axios
        .post((props.app_hostname || '') + '/api/market/itemlist/byshopid', formData, {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data;',
            Authorization: 'Bearer ' + props.permitdata.token,
          },
        })
        .then((response) => {
          if (response.data.status === 'OK' && response.data.shopinfo) {
            const si = response.data.shopinfo;
            setBankInfo({
              bankname: si.bank_name || si.shop_bankname || '-',
              bankno: si.bank_acc_id || si.shop_bankno || '-',
              bankaccountname: si.bank_acc_name || si.shop_bankaccountname || '-',
            });
          }
          setBankLoaded(true);
        })
        .catch(() => {
          setBankLoaded(true);
        });
    }
  }, [showUserInfo]);

  const pd = props.permitdata;

  const fullAddress = pd
    ? [pd.shop_address, pd.shop_subdistrict, pd.shop_district, pd.shop_province, pd.shop_postcode]
        .filter((v) => v && v !== '-')
        .join(' ') || '-'
    : '-';

  return (
    <div className='col d-block'>
      {props.islogin === false ? (
        <div className='d-none d-xl-block col-md-auto float-right'>
          <div
            className='d-flex user-info-trigger'
            style={{ cursor: 'pointer', position: 'relative' }}
            ref={userInfoRef}
            onClick={() => setShowUserInfo(!showUserInfo)}
          >
            <i className='ec ec-user font-size-30 text-primary'></i>
            <div className='ml-2'>
              <div className='phone'>
                <strong className='text-primary font-th'>
                  {pd && pd.shop_name !== '-' ? pd.shop_name : 'ร้านค้าของฉัน'}
                </strong>
              </div>
              <div className='email'>
                <span className='text-gray-90'>
                  {pd && pd.shop_email !== '-' ? pd.shop_email : ''}
                </span>
              </div>
            </div>

            {showUserInfo && pd && (
              <div className='user-info-popup font-th' onClick={(e) => e.stopPropagation()}>
                <div className='uip-header'>
                  <div className='uip-avatar'>
                    <i className='ec ec-user'></i>
                  </div>
                  <div className='uip-header-info'>
                    <div className='uip-shop-name'>
                      {pd.shop_name !== '-' ? pd.shop_name : 'ร้านค้าของฉัน'}
                    </div>
                    <div className='uip-email'>{pd.shop_email !== '-' ? pd.shop_email : ''}</div>
                  </div>
                </div>
                <div
                  className='uip-coins-banner'
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    setShowUserInfo(false);
                    navigate('/me');
                  }}
                >
                  <div className='d-flex align-items-center justify-content-between'>
                    <div className='d-flex align-items-center'>
                      <i className='fas fa-coins text-warning mr-2' style={{ fontSize: '16px' }}></i>
                      <span style={{ fontWeight: 600, color: '#78350f', fontSize: '13px' }}>
                        กระเป๋า Meya Coins
                      </span>
                    </div>
                    <span style={{ fontWeight: 600, color: '#b45309', fontSize: '12px' }}>
                      ดูประวัติ &rsaquo;
                    </span>
                  </div>
                </div>
                <div className='uip-section'>
                  <div className='uip-section-title'>
                    <i className='fas fa-user-circle'></i> ข้อมูลผู้ใช้
                  </div>
                  <div className='uip-grid'>
                    <div className='uip-cell'>
                      <span className='uip-label'>รหัสร้านค้า</span>
                      <span className='uip-value'>{pd.shop_id || '-'}</span>
                    </div>
                    <div className='uip-cell'>
                      <span className='uip-label'>ชื่อผู้ใช้</span>
                      <span className='uip-value'>{pd.shop_username || '-'}</span>
                    </div>
                    <div className='uip-cell'>
                      <span className='uip-label'>ชื่อจริง</span>
                      <span className='uip-value'>
                        {pd.shop_firstname !== '-' ? pd.shop_firstname : '-'}
                      </span>
                    </div>
                    <div className='uip-cell'>
                      <span className='uip-label'>นามสกุล</span>
                      <span className='uip-value'>
                        {pd.shop_lastname !== '-' ? pd.shop_lastname : '-'}
                      </span>
                    </div>
                    <div className='uip-cell'>
                      <span className='uip-label'>เบอร์โทร</span>
                      <span className='uip-value'>
                        {pd.shop_telno !== '-' ? pd.shop_telno : '-'}
                      </span>
                    </div>
                    <div className='uip-cell'>
                      <span className='uip-label'>จังหวัด</span>
                      <span className='uip-value'>
                        {pd.shop_province !== '-' ? pd.shop_province : '-'}
                      </span>
                    </div>
                    <div className='uip-cell uip-cell-full'>
                      <span className='uip-label'>ที่อยู่</span>
                      <span className='uip-value'>{fullAddress}</span>
                    </div>
                  </div>
                </div>
                <div className='uip-footer'>
                  <span>
                    หากต้องการแก้ไขข้อมูล ติดต่อ Line <strong>@meya</strong>
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className='col-auto float-right mx-0'>
          <div className='d-none d-md-flex'>
            <button
              className='btn btn-primary btn-sm text-white font-th mr-2'
              type='button'
              onClick={props.callback_popup_register}
            >
              ลงทะเบียน
            </button>
            <button
              className='btn btn-primary btn-sm text-white font-th'
              type='button'
              onClick={props.callback_popup_signin}
            >
              เข้าสู่ระบบ
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

function NavbarSearch(props) {
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [navigate_url, setNavigate_url] = useState('');
  const [filtertext, setFiltertext] = useState('');
  const [debouncedText, setDebouncedText] = useState('');
  const [searchoption, setSearchoption] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [recentSearches, setRecentSearches] = useState([]);
  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const popupref = useDetectClickOutside({ onTriggered: closesearchoption });
  function closesearchoption() {
    setSearchoption(false);
    setActiveIndex(-1);
  }
  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });

  function showDialogCallback_General(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function showDialogCallback_Confirm(message) {}

  // Load search history from localStorage
  useEffect(() => {
    const history = localStorage.getItem('meya_recent_searches');
    if (history) {
      try {
        setRecentSearches(JSON.parse(history));
      } catch (e) {
        setRecentSearches([]);
      }
    }
  }, []);

  const addRecentSearch = (text) => {
    if (!text || text.trim() === '') return;
    const cleanText = text.trim();
    const updated = [cleanText, ...recentSearches.filter((item) => item !== cleanText)].slice(0, 5);
    setRecentSearches(updated);
    localStorage.setItem('meya_recent_searches', JSON.stringify(updated));
  };

  const removeRecentSearch = (e, text) => {
    e.stopPropagation();
    const updated = recentSearches.filter((item) => item !== text);
    setRecentSearches(updated);
    localStorage.setItem('meya_recent_searches', JSON.stringify(updated));
  };

  const clearAllRecentSearches = (e) => {
    e.stopPropagation();
    setRecentSearches([]);
    localStorage.removeItem('meya_recent_searches');
  };

  // Debouncing Input Search
  useEffect(() => {
    setIsLoading(true);
    const handler = setTimeout(() => {
      setDebouncedText(filtertext);
      setIsLoading(false);
    }, 300);
    return () => clearTimeout(handler);
  }, [filtertext]);

  useEffect(() => {
    if (filtertext !== '') {
      setSearchoption(true);
    }
  }, [filtertext]);

  useEffect(() => {
    if (!debouncedText) {
      if (props.productCatalog?.clear) {
        props.productCatalog.clear();
      }
      return;
    }

    // Trigger server-side product search via productCatalog hook (page 1)
    if (props.productCatalog?.search) {
      props.productCatalog.search(debouncedText, 'buyer_category');
    }
  }, [debouncedText, props.productCatalog?.search]);

  // Search for shop by name (search-as-you-type)
  const apiMatchedShop = useShopSearch(debouncedText);

  // Stop loading when products arrive
  useEffect(() => {
    if (isLoadingMore && !props.productCatalog?.loading) {
      setIsLoadingMore(false);
    }
  }, [props.productCatalog?.loading, isLoadingMore]);

  // Extract unique shops from productCatalog
  const uniqueShops = useMemo(() => {
    try {
      if (!props.productCatalog?.products) return [];
      const seen = new Set();
      const shops = [];
      props.productCatalog.products.forEach((item) => {
        if (item && item.shop_id && !seen.has(item.shop_id)) {
          seen.add(item.shop_id);
          shops.push({
            shop_id: item.shop_id,
            shop_name: item.shop_name || 'ร้านขายยาไม่ระบุชื่อ',
            shop_province: item.shop_province || 'กรุงเทพมหานคร',
          });
        }
      });
      return shops;
    } catch (e) {
      console.error('Error in uniqueShops useMemo:', e);
      return [];
    }
  }, [props.productCatalog?.products]);

  // Filter lists based on debouncedText
  const filteredShops = useMemo(() => {
    try {
      if (!debouncedText) return [];
      const searchWord = debouncedText.toLowerCase();
      const norm = (s) =>
        String(s || '')
          .replace(/[^a-zA-Z0-9\u0E00-\u0E7F]/g, '')
          .toLowerCase();
      const searchWordNorm = norm(debouncedText);
      const queryTokens = searchWord.split(/\s+/).filter(Boolean);
      const queryNormTokens = searchWordNorm.split(/\s+/).filter(Boolean);

      let localFiltered = uniqueShops.filter((shop) => {
        const name = shop && shop.shop_name ? String(shop.shop_name).toLowerCase() : '';
        const province = shop && shop.shop_province ? String(shop.shop_province).toLowerCase() : '';

        // 1. Direct substring match
        if (name.includes(searchWord) || province.includes(searchWord)) {
          return true;
        }

        // 2. Normalized substring match
        const nameNorm = norm(name);
        const provinceNorm = norm(province);
        if (nameNorm.includes(searchWordNorm) || provinceNorm.includes(searchWordNorm)) {
          return true;
        }

        // 3. Token-based match (all search terms must match somewhere in name or province)
        if (queryTokens.length > 1) {
          const allTokensMatch = queryTokens.every(
            (token) => name.includes(token) || province.includes(token),
          );
          if (allTokensMatch) return true;
        }

        // 4. Normalized token-based match
        if (queryNormTokens.length > 0) {
          const allNormTokensMatch = queryNormTokens.every(
            (token) => nameNorm.includes(token) || provinceNorm.includes(token),
          );
          if (allNormTokensMatch) return true;
        }

        return false;
      });
      if (apiMatchedShop) {
        const alreadyExists = localFiltered.some((s) => s.shop_id === apiMatchedShop.shop_id);
        if (!alreadyExists) {
          localFiltered = [apiMatchedShop, ...localFiltered];
        }
      }
      return localFiltered;
    } catch (e) {
      console.error('Error in filteredShops useMemo:', e);
      return [];
    }
  }, [debouncedText, uniqueShops, apiMatchedShop]);

  // Use accumulated results (for load more support)
  const filteredProducts = useMemo(() => {
    try {
      return props.productCatalog?.products || [];
    } catch (e) {
      console.error('Error in filteredProducts useMemo:', e);
      return [];
    }
  }, [props.productCatalog?.products]);

  const popularKeywords = [
    'พาราเซตามอล',
    'ยาแก้ไอ',
    'วิตามินซี',
    'หน้ากากอนามัย 3D',
    'ยาหยอดตา',
    'ฟ้าทะลายโจร',
  ];

  const suggestedShops = useMemo(() => {
    try {
      return uniqueShops.slice(0, 3);
    } catch (e) {
      return [];
    }
  }, [uniqueShops]);

  const suggestedProducts = useMemo(() => {
    try {
      if (!props.productCatalog?.products) return [];
      return props.productCatalog.products.slice(0, 3);
    } catch (e) {
      return [];
    }
  }, [props.productCatalog?.products]);

  // Flat array representing all clickable elements for Keyboard Navigation
  const flatResults = useMemo(() => {
    try {
      const list = [];
      filteredShops.forEach((shop) => {
        if (shop) {
          list.push({
            type: 'shop',
            id: shop.shop_id,
            name: shop.shop_name,
            province: shop.shop_province,
          });
        }
      });
      filteredProducts.forEach((item) => {
        if (item) {
          list.push({
            type: 'product',
            id: item.productitem_id,
            name: item.productitem_name,
            detail: item.productitem_name,
            shopitem_id: item.shopitem_id,
            img1_key: item.img1_key,
            inter: item.productitem_inter,
            price: item.first_pricenew > 0 ? item.first_pricenew : item.first_pricebase,
          });
        }
      });
      if (debouncedText) {
        list.push({
          type: 'all',
          name: `ค้นหา "${debouncedText}" ในสินค้าทั้งหมด`,
          keyword: debouncedText,
        });
      }
      return list;
    } catch (e) {
      console.error('Error in flatResults useMemo:', e);
      return [];
    }
  }, [filteredShops, filteredProducts, debouncedText]);

  const handleLoadMore = () => {
    const nextPage = (props.productCatalog?.page || 1) + 1;
    setIsLoadingMore(true);
    // Only use loadPage to fetch the next page - avoid resetting with search()
    if (props.productCatalog?.loadPage) {
      props.productCatalog.loadPage(nextPage);
    }
  };

  function begin_search(mode, type, id, detail, customKeyword) {
    const keyword = customKeyword !== undefined ? customKeyword : filtertext;
    if (keyword !== '') {
      addRecentSearch(keyword);
      if (mode === 'shop') {
        getShopID(keyword);
      } else if (mode === 'product') {
        if (type === 'contain') {
          // Pre-check for local exact/normalized shop match before contacting backend
          const norm = (s) =>
            String(s || '')
              .replace(/[^a-zA-Z0-9\u0E00-\u0E7F]/g, '')
              .toLowerCase();
          const keywordNorm = norm(keyword);
          if (keywordNorm) {
            const matchedShop = uniqueShops.find((shop) => {
              const shopNameNorm = norm(shop.shop_name);
              return shopNameNorm === keywordNorm;
            });
            if (matchedShop) {
              setNavigate_url(
                '/marketplace/shopseller?shopcode=' + matchedShop.shop_id + '&category=รวมสินค้า',
              );
              setSearchoption(false);
              setFiltertext('');
              setActiveIndex(-1);
              return;
            }
          }

          var formdata = new FormData();
          formdata.append('shop_text', keyword);
          const headers = { Accept: 'application/json' };
          if (props.permitdata && props.permitdata.token) {
            headers.Authorization = 'Bearer ' + props.permitdata.token;
          }
          axios
            .post(props.app_hostname + '/api/market/help/getshopidbyname', formdata, { headers })
            .then((response) => {
              if (
                response.data.status === 'OK' &&
                Array.isArray(response.data.shop_info) &&
                response.data.shop_info.length > 0
              ) {
                setNavigate_url(
                  '/marketplace/shopseller?shopcode=' +
                    response.data.shop_info[0].shop_id +
                    '&category=รวมสินค้า',
                );
              } else {
                setNavigate_url(
                  '/marketplace?category=ค้นหาสินค้า&searchtype=contain&productid=none&detail=' +
                    keyword,
                );
              }
            })
            .catch(() => {
              setNavigate_url(
                '/marketplace?category=ค้นหาสินค้า&searchtype=contain&productid=none&detail=' +
                  keyword,
              );
            });
        } else if (type === 'productid') {
          setNavigate_url(
            '/marketplace?category=ค้นหาสินค้า&searchtype=productid&productid=' +
              id +
              '&detail=' +
              keyword,
          );
        }
      }
      setSearchoption(false);
      setFiltertext('');
      setActiveIndex(-1);
    }
  }

  useEffect(() => {
    if (navigate_url !== '') {
      return navigate(navigate_url);
    }
  }, [navigate_url]);

  function getShopID(text) {
    var formdata = new FormData();
    formdata.append('shop_text', text);
    const headers = { Accept: 'application/json' };
    if (props.permitdata && props.permitdata.token) {
      headers.Authorization = 'Bearer ' + props.permitdata.token;
    }
    axios
      .post(props.app_hostname + '/api/market/help/getshopidbyname', formdata, { headers })
      .then((response) => {
        if (response.data.status === 'OK') {
          if (Array.isArray(response.data.shop_info) && response.data.shop_info.length > 0) {
            setNavigate_url(
              '/marketplace/shopseller?shopcode=' +
                response.data.shop_info[0].shop_id +
                '&category=รวมสินค้า',
            );
            setFiltertext('');
          } else {
            setModal_popup({
              modaltype: 'modal-warning',
              headers: 'ขออภัย',
              message: 'ไม่พบร้านค้าที่ท่านต้องการค้นหา กรุณาลองใหม่อีกครั้ง',
              enable: true,
            });
          }
        } else {
          setModal_popup({
            modaltype: 'modal-warning',
            headers: 'ขออภัย',
            message: response.data.message,
            enable: true,
          });
        }
      })
      .catch((err) => {
        setModal_popup({
          modaltype: 'modal-error',
          headers: 'ผิดพลาด',
          message: err.message,
          enable: true,
        });
      });
  }

  const handleSelectOption = (item) => {
    if (item.type === 'shop') {
      addRecentSearch(item.name);
      setFiltertext('');
      setSearchoption(false);
      setNavigate_url('/marketplace/shopseller?shopcode=' + item.id + '&category=รวมสินค้า');
    } else if (item.type === 'product') {
      addRecentSearch(item.name);
      setFiltertext('');
      setSearchoption(false);
      setNavigate_url(
        '/marketplace?category=ค้นหาสินค้า&searchtype=productid&productid=' +
          item.id +
          '&detail=' +
          item.name,
      );
    } else if (item.type === 'all') {
      addRecentSearch(item.keyword);
      begin_search('product', 'contain', null, null, item.keyword);
    }
  };

  const handleKeyDown = (e) => {
    if (!searchoption) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActiveIndex((prev) => (prev + 1) % flatResults.length);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActiveIndex((prev) => (prev - 1 + flatResults.length) % flatResults.length);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (activeIndex >= 0 && activeIndex < flatResults.length) {
        const selected = flatResults[activeIndex];
        handleSelectOption(selected);
      } else {
        begin_search('product', 'contain');
      }
    } else if (e.key === 'Escape') {
      setSearchoption(false);
      inputRef.current?.blur();
      setActiveIndex(-1);
    }
  };

  function generate_token(length) {
    var a = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'.split('');
    var b = [];
    for (var i = 0; i < length; i++) {
      var j = (Math.random() * (a.length - 1)).toFixed(0);
      b[i] = a[j];
    }
    return b.join('');
  }

  // Calculate absolute index offset for rendering active classes
  const getAbsoluteIndex = (type, relativeIdx) => {
    if (type === 'shop') return relativeIdx;
    if (type === 'product') return filteredShops.length + relativeIdx;
    if (type === 'all') return filteredShops.length + filteredProducts.length;
    return -1;
  };

  return (
    <div className='d-none d-xl-block bg-white border-bottom'>
      <div className='container'>
        <div className='row align-items-stretch min-height-50'>
          <div className='col-md-auto d-none d-xl-flex align-items-end'>
            <div className='max-width-200 min-width-200'></div>
          </div>

          <div className='col align-self-center' ref={popupref}>
            <div className='js-focus-state'>
              <label className='sr-only' htmlFor='searchProduct'>
                Search
              </label>
              <div
                className='input-group border'
                style={{ borderRadius: '20px', overflow: 'hidden', background: '#f5f5f5' }}
              >
                <input
                  ref={inputRef}
                  type='search'
                  className='form-control py-2 pl-5 font-size-15 border-0 height-40 font-th'
                  style={{ background: 'transparent' }}
                  name='email'
                  id='searchProduct'
                  placeholder='ค้นหาสินค้าและร้านค้า'
                  aria-label='Search for Products'
                  aria-describedby='searchProduct1'
                  value={filtertext}
                  onKeyDown={handleKeyDown}
                  onChange={(e) => {
                    setFiltertext(e.target.value);
                  }}
                  onClick={() => {
                    setSearchoption(true);
                  }}
                  required
                />
                <div className='input-group-append'>
                  <div
                    className='btn height-40 px-2 d-flex align-items-center justify-content-center'
                    title='สแกนบาร์โค้ด'
                    style={{ cursor: 'pointer', color: '#555', background: 'transparent' }}
                    onClick={() => setIsScannerOpen(true)}
                  >
                    <i className='fas fa-expand' style={{ fontSize: '18px' }}></i>
                  </div>
                  <div
                    className='btn height-40 py-2 px-3'
                    type='button'
                    id='searchProduct1'
                    style={{ background: 'transparent' }}
                    onClick={() => {
                      begin_search('product', 'contain');
                    }}
                  >
                    <i className='fas fa-search text-primary'></i>
                  </div>
                </div>
              </div>
            </div>
            {isScannerOpen && (
              <BarcodeScanner
                onScanSuccess={(code) => {
                  setIsScannerOpen(false);
                  if (!code) return;
                  const scanCode = code.trim();
                  setFiltertext(scanCode);

                  if (props.buyer_products && props.buyer_products.length > 0) {
                    const norm = (s) =>
                      String(s)
                        .replace(/[^a-zA-Z0-9]/g, '')
                        .toLowerCase();
                    const searchNorm = norm(scanCode);
                    const found = props.buyer_products.find(
                      (item) =>
                        (item.productitem_barcode &&
                          norm(item.productitem_barcode) === searchNorm) ||
                        (item.productitem_id && norm(item.productitem_id) === searchNorm),
                    );
                    if (found) {
                      begin_search(
                        'product',
                        'productid',
                        found.productitem_id,
                        found.productitem_name,
                      );
                    } else {
                      begin_search('product', 'contain');
                    }
                  } else {
                    begin_search('product', 'contain');
                  }
                }}
                onClose={() => setIsScannerOpen(false)}
              />
            )}
            {searchoption === true && props.islogin === false ? (
              <div className='search-bar-auto'>
                <div className='search-bar-auto-wrapper'>
                  {isLoading ? (
                    // Skeleton Loading State
                    <div className='search-section'>
                      <div className='search-skeleton-item'>
                        <div className='search-skeleton-circle'></div>
                        <div className='search-skeleton-bar'></div>
                      </div>
                      <div className='search-skeleton-item'>
                        <div className='search-skeleton-circle'></div>
                        <div className='search-skeleton-bar'></div>
                      </div>
                      <div className='search-skeleton-item'>
                        <div className='search-skeleton-circle'></div>
                        <div className='search-skeleton-bar'></div>
                      </div>
                    </div>
                  ) : filtertext === '' ? (
                    // Smart Suggestions before Typing
                    <div className='search-suggestions-flow'>
                      {recentSearches.length > 0 && (
                        <div className='search-section'>
                          <div className='d-flex align-items-center justify-content-between mb-2'>
                            <div className='search-section-title mb-0 border-0'>🕘 ค้นหาล่าสุด</div>
                            <button
                              className='btn btn-link text-muted font-size-12 p-0'
                              onClick={clearAllRecentSearches}
                              style={{ textDecoration: 'none' }}
                            >
                              ล้างทั้งหมด
                            </button>
                          </div>
                          {recentSearches.map((phrase, idx) => (
                            <div
                              key={idx}
                              className='search-bar-auto-item history-item'
                              onClick={() => {
                                setFiltertext(phrase);
                                begin_search('product', 'contain', null, null, phrase);
                              }}
                            >
                              <div className='history-text-wrap'>
                                <i className='far fa-clock'></i>
                                <span className='item-name'>{phrase}</span>
                              </div>
                              <button
                                className='btn-remove-history'
                                onClick={(e) => removeRecentSearch(e, phrase)}
                              >
                                <i className='fas fa-times'></i>
                              </button>
                            </div>
                          ))}
                        </div>
                      )}

                      {suggestedShops.length > 0 && (
                        <div className='search-section'>
                          <div className='search-section-title'>🏪 ร้านขายยาแนะนำ</div>
                          <div className='row no-gutters' style={{ gap: '8px' }}>
                            {suggestedShops.map((shop, idx) => (
                              <div key={idx} className='col-12 col-md-3'>
                                <div
                                  className='search-pill'
                                  style={{ width: '100%', borderRadius: '12px' }}
                                  onClick={() =>
                                    handleSelectOption({
                                      type: 'shop',
                                      id: shop.shop_id,
                                      name: shop.shop_name,
                                    })
                                  }
                                >
                                  <i className='fas fa-store text-primary'></i>
                                  <div className='text-truncate' style={{ maxWidth: '140px' }}>
                                    {shop.shop_name}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ) : filteredShops.length === 0 && filteredProducts.length === 0 ? (
                    // Empty State
                    <div className='search-empty-state'>
                      <div className='search-empty-icon'>
                        <i className='fas fa-search'></i>
                      </div>
                      <h5 className='search-empty-title'>
                        ไม่พบสินค้าหรือร้านค้าที่ท่านต้องการค้นหา
                      </h5>
                      <p className='search-empty-desc'>
                        ขออภัยด้วยค่ะ ลองพิมพ์ข้อความใหม่หรือค้นหาโดยใช้คำแนะนำด้านล่างนี้ดูนะคะ
                      </p>
                    </div>
                  ) : (
                    // Search Matching Results Classified
                    <>
                      {filteredShops.length > 0 && (
                        <div className='search-section'>
                          <label className='search-section-title'>🏪 ร้านขายยา</label>
                          {filteredShops.map((shop, index) => {
                            const absIdx = getAbsoluteIndex('shop', index);
                            return (
                              <div
                                key={index}
                                className={`search-bar-auto-item ${activeIndex === absIdx ? 'search-item-active' : ''}`}
                                onClick={() =>
                                  handleSelectOption({
                                    type: 'shop',
                                    id: shop.shop_id,
                                    name: shop.shop_name,
                                  })
                                }
                              >
                                <div className='item-avatar'>
                                  <i className='fas fa-store-alt'></i>
                                </div>
                                <div className='item-details'>
                                  <span className='item-name'>{shop.shop_name}</span>
                                </div>
                                <span className='item-meta'>
                                  <i className='fas fa-map-marker-alt mr-1'></i>{' '}
                                  {shop.shop_province}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      )}

                      {filteredProducts.length > 0 && (
                        <div className='search-section'>
                          <label className='search-section-title'>💊 สินค้า</label>
                          {filteredProducts.map((item, index) => {
                            const absIdx = getAbsoluteIndex('product', index);
                            return (
                              <div
                                key={index}
                                className={`search-bar-auto-item ${activeIndex === absIdx ? 'search-item-active' : ''}`}
                                onClick={() =>
                                  handleSelectOption({
                                    type: 'product',
                                    shopitem_id: item.shopitem_id,
                                    id: item.productitem_id,
                                    name: item.productitem_name,
                                  })
                                }
                              >
                                {item.img1_key && item.productitem_id ? (
                                  <div className='item-thumbnail'>
                                    <img
                                      src={`${process.env.REACT_APP_IMAGE_URL}${item.productitem_id}/${item.productitem_id}-1-${item.img1_key}.jpg`}
                                      alt={item.productitem_name}
                                      onError={(e) => {
                                        e.currentTarget.src = require('../../assets/images/placeholder.webp');
                                      }}
                                    />
                                  </div>
                                ) : (
                                  <div className='item-avatar'>
                                    <i className='fas fa-capsules'></i>
                                  </div>
                                )}
                                <div className='item-details'>
                                  <span className='item-name'>{item.productitem_name}</span>
                                  {item.productitem_inter && (
                                    <span className='item-sub'>{item.productitem_inter}</span>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                          {(props.productCatalog?.total || 0) >
                            (props.productCatalog?.products?.length || 0) && (
                            <button
                              className='btn btn-link w-100 text-center py-2'
                              onClick={handleLoadMore}
                              disabled={isLoadingMore}
                              style={{
                                fontSize: '13px',
                                color: '#2196F3',
                                fontWeight: '600',
                                borderTop: `1px solid ${colors.slate100}`,
                                marginTop: '8px',
                                cursor: isLoadingMore ? 'not-allowed' : 'pointer',
                                opacity: isLoadingMore ? 0.6 : 1,
                              }}
                            >
                              {isLoadingMore ? (
                                <>
                                  <i className='fas fa-spinner fa-spin mr-1'></i> กำลังโหลด...
                                </>
                              ) : (
                                <>
                                  <i className='fas fa-chevron-down mr-1'></i> โหลดเพิ่มเติม (
                                  {props.productCatalog?.products?.length || 0}/
                                  {props.productCatalog?.total || 0})
                                </>
                              )}
                            </button>
                          )}
                        </div>
                      )}

                      {/* Bottom Option: Search full text */}
                      {flatResults.length > 0 && (
                        <div
                          className={`search-bar-auto-item ${activeIndex === getAbsoluteIndex('all', 0) ? 'search-item-active' : ''}`}
                          style={{
                            borderTop: `1px solid ${colors.slate100}`,
                            marginTop: '4px',
                            paddingTop: '12px',
                          }}
                          onClick={() =>
                            handleSelectOption({ type: 'all', keyword: debouncedText })
                          }
                        >
                          <i className='fas fa-search text-primary'></i>
                          <span className='item-name' style={{ fontWeight: '700' }}>
                            ค้นหา "{debouncedText}" ในสินค้าทั้งหมด
                          </span>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            ) : null}
          </div>
          <div className='col-md-auto align-self-center'>
            {props.permitdata !== null && sessionStorage.getItem('meya-job-loggedin') !== 'true' ? (
              props.permitdata.role !== 'guest' &&
              props.permitdata.token !== '' &&
              props.permitdata.token !== '-' ? (
                <div className='d-flex'>
                  <ul className='d-flex list-unstyled mb-0'>
                    <li className='col pr-1'>
                      <Link
                        to={'/marketplace/mycart?cart=' + generate_token(20)}
                        className='text-primary position-relative d-flex '
                        data-toggle='tooltip'
                        data-placement='top'
                        title='ตะกร้าสินค้าของฉัน'
                      >
                        <i className='font-size-28 ec ec-add-to-cart'></i>
                        {props.mycartlen > 0 ? (
                          <span className='width-22 height-22 bg-danger position-absolute flex-content-center text-white rounded-circle left-15 top-0 font-weight-bold font-size-12'>
                            {props.mycartlen}
                          </span>
                        ) : null}
                      </Link>
                    </li>
                  </ul>
                </div>
              ) : null
            ) : null}
          </div>
        </div>
      </div>

      <ModalPopupMessage
        callback_general={(message) => {
          showDialogCallback_General(message);
        }}
        callback_confirm={(message) => {
          showDialogCallback_Confirm(message);
        }}
        options={modal_popup}
      />
    </div>
  );
}

function NavbarSearchTablet(props) {
  const searchbarRef = useRef(null);
  const [searchbar_toggle, setSearchbar_toggle] = useState(false);
  const [searchbar_firstload, setSearchbar_firstload] = useState(true);

  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [navigate_url, setNavigate_url] = useState('');
  const [filtertext, setFiltertext] = useState('');
  const [debouncedText, setDebouncedText] = useState('');
  const [searchoption, setSearchoption] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [recentSearches, setRecentSearches] = useState([]);
  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });

  function showDialogCallback_General(message) {
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function showDialogCallback_Confirm(message) {}

  useEffect(() => {
    if (searchbar_toggle) {
      const searchbar = searchbarRef.current;
      searchbar.className =
        'dropdown-menu dropdown-unfold dropdown-menu-right left-0 mx-2 u-unfold--css-animation slideInUp';
      setSearchbar_firstload(false);
    } else {
      if (searchbar_firstload === false) {
        const searchbar = searchbarRef.current;
        searchbar.className =
          'dropdown-menu dropdown-unfold dropdown-menu-right left-0 mx-2 u-unfold--css-animation fadeOut';
      } else {
        const searchbar = searchbarRef.current;
        searchbar.className =
          'dropdown-menu dropdown-unfold dropdown-menu-right left-0 mx-2 u-unfold--css-animation u-unfold--hidden';
      }
    }
  }, [searchbar_toggle]);

  function searchbarClose() {
    if (searchbar_toggle === false) {
      const searchbar = searchbarRef.current;
      searchbar.className =
        'dropdown-menu dropdown-unfold dropdown-menu-right left-0 mx-2 u-unfold--css-animation u-unfold--hidden fadeOut';
    }
  }

  // Load search history from localStorage
  useEffect(() => {
    const history = localStorage.getItem('meya_recent_searches');
    if (history) {
      try {
        setRecentSearches(JSON.parse(history));
      } catch (e) {
        setRecentSearches([]);
      }
    }
  }, []);

  const addRecentSearch = (text) => {
    if (!text || text.trim() === '') return;
    const cleanText = text.trim();
    const updated = [cleanText, ...recentSearches.filter((item) => item !== cleanText)].slice(0, 5);
    setRecentSearches(updated);
    localStorage.setItem('meya_recent_searches', JSON.stringify(updated));
  };

  const removeRecentSearch = (e, text) => {
    e.stopPropagation();
    const updated = recentSearches.filter((item) => item !== text);
    setRecentSearches(updated);
    localStorage.setItem('meya_recent_searches', JSON.stringify(updated));
  };

  const clearAllRecentSearches = (e) => {
    e.stopPropagation();
    setRecentSearches([]);
    localStorage.removeItem('meya_recent_searches');
  };

  // Debouncing Input Search
  useEffect(() => {
    setIsLoading(true);
    const handler = setTimeout(() => {
      setDebouncedText(filtertext);
      setIsLoading(false);
    }, 300);
    return () => clearTimeout(handler);
  }, [filtertext]);

  useEffect(() => {
    if (filtertext !== '') {
      setSearchoption(true);
    }
  }, [filtertext]);

  useEffect(() => {
    if (!debouncedText) {
      if (props.productCatalog?.clear) {
        props.productCatalog.clear();
      }
      return;
    }

    // Trigger server-side product search via productCatalog hook (page 1)
    if (props.productCatalog?.search) {
      props.productCatalog.search(debouncedText, 'buyer_category');
    }
  }, [debouncedText, props.productCatalog?.search]);

  // Search for shop by name (search-as-you-type)
  const apiMatchedShop = useShopSearch(debouncedText);

  // Stop loading when products arrive
  useEffect(() => {
    if (isLoadingMore && !props.productCatalog?.loading) {
      setIsLoadingMore(false);
    }
  }, [props.productCatalog?.loading, isLoadingMore]);

  const handleLoadMore = () => {
    const nextPage = (props.productCatalog?.page || 1) + 1;
    setIsLoadingMore(true);
    // Only use loadPage to fetch the next page - avoid resetting with search()
    if (props.productCatalog?.loadPage) {
      props.productCatalog.loadPage(nextPage);
    }
  };

  const uniqueShops = useMemo(() => {
    try {
      if (!props.productCatalog?.products) return [];
      const seen = new Set();
      const shops = [];
      props.productCatalog.products.forEach((item) => {
        if (item && item.shop_id && !seen.has(item.shop_id)) {
          seen.add(item.shop_id);
          shops.push({
            shop_id: item.shop_id,
            shop_name: item.shop_name || 'ร้านขายยาไม่ระบุชื่อ',
            shop_province: item.shop_province || 'กรุงเทพมหานคร',
          });
        }
      });
      return shops;
    } catch (e) {
      console.error('Error in Tablet uniqueShops useMemo:', e);
      return [];
    }
  }, [props.productCatalog?.products]);

  // Filter lists based on debouncedText
  const filteredShops = useMemo(() => {
    try {
      if (!debouncedText) return [];
      const searchWord = debouncedText.toLowerCase();
      const norm = (s) =>
        String(s || '')
          .replace(/[^a-zA-Z0-9\u0E00-\u0E7F]/g, '')
          .toLowerCase();
      const searchWordNorm = norm(debouncedText);
      const queryTokens = searchWord.split(/\s+/).filter(Boolean);
      const queryNormTokens = searchWordNorm.split(/\s+/).filter(Boolean);

      let localFiltered = uniqueShops.filter((shop) => {
        const name = shop && shop.shop_name ? String(shop.shop_name).toLowerCase() : '';
        const province = shop && shop.shop_province ? String(shop.shop_province).toLowerCase() : '';

        // 1. Direct substring match
        if (name.includes(searchWord) || province.includes(searchWord)) {
          return true;
        }

        // 2. Normalized substring match
        const nameNorm = norm(name);
        const provinceNorm = norm(province);
        if (nameNorm.includes(searchWordNorm) || provinceNorm.includes(searchWordNorm)) {
          return true;
        }

        // 3. Token-based match (all search terms must match somewhere in name or province)
        if (queryTokens.length > 1) {
          const allTokensMatch = queryTokens.every(
            (token) => name.includes(token) || province.includes(token),
          );
          if (allTokensMatch) return true;
        }

        // 4. Normalized token-based match
        if (queryNormTokens.length > 0) {
          const allNormTokensMatch = queryNormTokens.every(
            (token) => nameNorm.includes(token) || provinceNorm.includes(token),
          );
          if (allNormTokensMatch) return true;
        }

        return false;
      });
      if (apiMatchedShop) {
        const alreadyExists = localFiltered.some((s) => s.shop_id === apiMatchedShop.shop_id);
        if (!alreadyExists) {
          localFiltered = [apiMatchedShop, ...localFiltered];
        }
      }
      return localFiltered;
    } catch (e) {
      console.error('Error in Tablet filteredShops useMemo:', e);
      return [];
    }
  }, [debouncedText, uniqueShops, apiMatchedShop]);

  // Use accumulated results (for load more support)
  const filteredProducts = useMemo(() => {
    try {
      return props.productCatalog?.products || [];
    } catch (e) {
      console.error('Error in Tablet filteredProducts useMemo:', e);
      return [];
    }
  }, [props.productCatalog?.products]);

  const popularKeywords = [
    'พาราเซตามอล',
    'ยาแก้ไอ',
    'วิตามินซี',
    'หน้ากากอนามัย 3D',
    'ยาหยอดตา',
    'ฟ้าทะลายโจร',
  ];

  const suggestedShops = useMemo(() => {
    try {
      return uniqueShops.slice(0, 3);
    } catch (e) {
      return [];
    }
  }, [uniqueShops]);

  const suggestedProducts = useMemo(() => {
    try {
      if (!props.productCatalog?.products) return [];
      return props.productCatalog.products.slice(0, 3);
    } catch (e) {
      return [];
    }
  }, [props.productCatalog?.products]);

  // Flat array representing all clickable elements for Keyboard Navigation
  const flatResults = useMemo(() => {
    try {
      const list = [];
      filteredShops.forEach((shop) => {
        if (shop) {
          list.push({
            type: 'shop',
            id: shop.shop_id,
            name: shop.shop_name,
            province: shop.shop_province,
          });
        }
      });
      filteredProducts.forEach((item) => {
        if (item) {
          list.push({
            type: 'product',
            id: item.productitem_id,
            name: item.productitem_name,
            detail: item.productitem_name,
            shopitem_id: item.shopitem_id,
            img1_key: item.img1_key,
            inter: item.productitem_inter,
            price: item.first_pricenew > 0 ? item.first_pricenew : item.first_pricebase,
          });
        }
      });
      if (debouncedText) {
        list.push({
          type: 'all',
          name: `ค้นหา "${debouncedText}" ในสินค้าทั้งหมด`,
          keyword: debouncedText,
        });
      }
      return list;
    } catch (e) {
      console.error('Error in Tablet flatResults useMemo:', e);
      return [];
    }
  }, [filteredShops, filteredProducts, debouncedText]);

  function closesearchoption() {
    setSearchoption(false);
    setActiveIndex(-1);
  }

  function begin_search(mode, type, id, detail, customKeyword) {
    const keyword = customKeyword !== undefined ? customKeyword : filtertext;
    if (keyword !== '') {
      addRecentSearch(keyword);
      if (mode === 'shop') {
        getShopID(keyword);
      } else if (mode === 'product') {
        if (type === 'contain') {
          // Pre-check for local exact/normalized shop match before contacting backend
          const norm = (s) =>
            String(s || '')
              .replace(/[^a-zA-Z0-9\u0E00-\u0E7F]/g, '')
              .toLowerCase();
          const keywordNorm = norm(keyword);
          if (keywordNorm) {
            const matchedShop = uniqueShops.find((shop) => {
              const shopNameNorm = norm(shop.shop_name);
              return shopNameNorm === keywordNorm;
            });
            if (matchedShop) {
              setNavigate_url(
                '/marketplace/shopseller?shopcode=' + matchedShop.shop_id + '&category=รวมสินค้า',
              );
              setSearchoption(false);
              setFiltertext('');
              setActiveIndex(-1);
              return;
            }
          }

          var formdata = new FormData();
          formdata.append('shop_text', keyword);
          const headers = { Accept: 'application/json' };
          if (props.permitdata && props.permitdata.token) {
            headers.Authorization = 'Bearer ' + props.permitdata.token;
          }
          axios
            .post(props.app_hostname + '/api/market/help/getshopidbyname', formdata, { headers })
            .then((response) => {
              if (
                response.data.status === 'OK' &&
                Array.isArray(response.data.shop_info) &&
                response.data.shop_info.length > 0
              ) {
                setNavigate_url(
                  '/marketplace/shopseller?shopcode=' +
                    response.data.shop_info[0].shop_id +
                    '&category=รวมสินค้า',
                );
              } else {
                setNavigate_url(
                  '/marketplace?category=ค้นหาสินค้า&searchtype=contain&productid=none&detail=' +
                    keyword,
                );
              }
            })
            .catch(() => {
              setNavigate_url(
                '/marketplace?category=ค้นหาสินค้า&searchtype=contain&productid=none&detail=' +
                  keyword,
              );
            });
        } else if (type === 'productid') {
          setNavigate_url(
            '/marketplace?category=ค้นหาสินค้า&searchtype=productid&productid=' +
              id +
              '&detail=' +
              keyword,
          );
        }
      }
      setSearchoption(false);
      setFiltertext('');
      setActiveIndex(-1);
    }
  }

  useEffect(() => {
    if (navigate_url !== '') {
      return navigate(navigate_url);
    }
  }, [navigate_url]);

  function getShopID(text) {
    var formdata = new FormData();
    formdata.append('shop_text', text);
    const headers = { Accept: 'application/json' };
    if (props.permitdata && props.permitdata.token) {
      headers.Authorization = 'Bearer ' + props.permitdata.token;
    }
    axios
      .post(props.app_hostname + '/api/market/help/getshopidbyname', formdata, { headers })
      .then((response) => {
        if (response.data.status === 'OK') {
          if (Array.isArray(response.data.shop_info) && response.data.shop_info.length > 0) {
            setNavigate_url(
              '/marketplace/shopseller?shopcode=' +
                response.data.shop_info[0].shop_id +
                '&category=รวมสินค้า',
            );
            setFiltertext('');
          } else {
            setModal_popup({
              modaltype: 'modal-warning',
              headers: 'ขออภัย',
              message: 'ไม่พบร้านค้าที่ท่านต้องการค้นหา กรุณาลองใหม่อีกครั้ง',
              enable: true,
            });
          }
        } else {
          setModal_popup({
            modaltype: 'modal-warning',
            headers: 'ขออภัย',
            message: response.data.message,
            enable: true,
          });
        }
      })
      .catch((err) => {
        setModal_popup({
          modaltype: 'modal-error',
          headers: 'ผิดพลาด',
          message: err.message,
          enable: true,
        });
      });
  }

  const handleSelectOption = (item) => {
    if (item.type === 'shop') {
      addRecentSearch(item.name);
      setFiltertext('');
      setSearchoption(false);
      setNavigate_url('/marketplace/shopseller?shopcode=' + item.id + '&category=รวมสินค้า');
    } else if (item.type === 'product') {
      addRecentSearch(item.name);
      setFiltertext('');
      setSearchoption(false);
      setNavigate_url(
        '/marketplace?category=ค้นหาสินค้า&searchtype=productid&productid=' +
          item.id +
          '&detail=' +
          item.name,
      );
    } else if (item.type === 'all') {
      addRecentSearch(item.keyword);
      begin_search('product', 'contain', null, null, item.keyword);
    }
  };

  const handleKeyDown = (e) => {
    if (!searchoption) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setActiveIndex((prev) => (prev + 1) % flatResults.length);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActiveIndex((prev) => (prev - 1 + flatResults.length) % flatResults.length);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (activeIndex >= 0 && activeIndex < flatResults.length) {
        const selected = flatResults[activeIndex];
        handleSelectOption(selected);
      } else {
        begin_search('product', 'contain');
      }
    } else if (e.key === 'Escape') {
      setSearchoption(false);
      inputRef.current?.blur();
      setActiveIndex(-1);
    }
  };

  const getAbsoluteIndex = (type, relativeIdx) => {
    if (type === 'shop') return relativeIdx;
    if (type === 'product') return filteredShops.length + relativeIdx;
    if (type === 'all') return filteredShops.length + filteredProducts.length;
    return -1;
  };

  function generate_token(length) {
    var a = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'.split('');
    var b = [];
    for (var i = 0; i < length; i++) {
      var j = (Math.random() * (a.length - 1)).toFixed(0);
      b[i] = a[j];
    }
    return b.join('');
  }

  return (
    <div className='d-xl-none col col-xl-auto text-right text-xl-left pl-0 pl-xl-0 position-static'>
      <div className='d-inline-flex'>
        <ul className='d-flex list-unstyled mb-0 align-items-center'>
          <li className='col d-xl-none px-1 px-sm-2 position-static'>
            <div
              id='searchClassicInvoker'
              className='font-size-22 text-dark text-lh-1 btn-text-secondary'
              role='button'
              data-toggle='tooltip'
              data-placement='top'
              title='ค้นหา'
              aria-controls='searchClassic'
              aria-haspopup='true'
              aria-expanded='false'
              onClick={() => {
                setSearchbar_toggle(!searchbar_toggle);
              }}
            >
              <i className='fas fa-search' style={{ cursor: 'pointer' }}></i>
            </div>

            <div
              id='searchClassic'
              ref={searchbarRef}
              onMouseLeave={() => setSearchbar_toggle(false)}
              className='dropdown-menu dropdown-unfold dropdown-menu-right left-0 mx-2 u-unfold--css-animation slideInUp'
              style={{ animationDuration: '500ms', left: ' 0px' }}
              onAnimationEnd={() => {
                searchbarClose();
              }}
              aria-labelledby='searchClassicInvoker'
            >
              <form className='js-focus-state input-group px-3'>
                <input
                  ref={inputRef}
                  className='form-control font-th'
                  type='search'
                  placeholder='ค้นหาสินค้าและร้านค้า'
                  value={filtertext}
                  style={{ borderRadius: '20px 0 0 20px' }}
                  onKeyDown={handleKeyDown}
                  onChange={(e) => {
                    setFiltertext(e.target.value);
                  }}
                  onClick={() => {
                    setSearchoption(true);
                  }}
                />
                <div className='input-group-append'>
                  <button
                    className='btn btn-white px-2 d-flex align-items-center justify-content-center border-left'
                    type='button'
                    title='สแกนบาร์โค้ด'
                    onClick={() => setIsScannerOpen(true)}
                  >
                    <i className='fas fa-expand' style={{ fontSize: '18px' }}></i>
                  </button>
                  <button
                    className='btn btn-primary px-3 text-white'
                    type='button'
                    style={{ borderRadius: '0 20px 20px 0' }}
                    onClick={() => {
                      begin_search('product', 'contain');
                    }}
                  >
                    <i className='fas fa-search font-size-18'></i>
                  </button>
                </div>
              </form>
              {isScannerOpen && (
                <BarcodeScanner
                  onScanSuccess={(code) => {
                    setIsScannerOpen(false);
                    if (!code) return;
                    const scanCode = code.trim();
                    setFiltertext(scanCode);

                    if (props.buyer_products && props.buyer_products.length > 0) {
                      const norm = (s) =>
                        String(s)
                          .replace(/[^a-zA-Z0-9]/g, '')
                          .toLowerCase();
                      const searchNorm = norm(scanCode);
                      const found = props.buyer_products.find(
                        (item) =>
                          (item.productitem_barcode &&
                            norm(item.productitem_barcode) === searchNorm) ||
                          (item.productitem_id && norm(item.productitem_id) === searchNorm),
                      );
                      if (found) {
                        begin_search(
                          'product',
                          'productid',
                          found.productitem_id,
                          found.productitem_name,
                        );
                      } else {
                        begin_search('product', 'contain');
                      }
                    } else {
                      begin_search('product', 'contain');
                    }
                  }}
                  onClose={() => setIsScannerOpen(false)}
                />
              )}
              <div className='px-3'>
                {searchoption === true && props.islogin === false ? (
                  <div className='search-bar-auto'>
                    <div className='search-bar-auto-wrapper'>
                      {isLoading ? (
                        <div className='search-section'>
                          <div className='search-skeleton-item'>
                            <div className='search-skeleton-circle'></div>
                            <div className='search-skeleton-bar'></div>
                          </div>
                          <div className='search-skeleton-item'>
                            <div className='search-skeleton-circle'></div>
                            <div className='search-skeleton-bar'></div>
                          </div>
                          <div className='search-skeleton-item'>
                            <div className='search-skeleton-circle'></div>
                            <div className='search-skeleton-bar'></div>
                          </div>
                        </div>
                      ) : filtertext === '' ? (
                        <div className='search-suggestions-flow'>
                          {recentSearches.length > 0 && (
                            <div className='search-section'>
                              <div className='d-flex align-items-center justify-content-between mb-2'>
                                <div className='search-section-title mb-0 border-0'>
                                  🕘 ค้นหาล่าสุด
                                </div>
                                <button
                                  className='btn btn-link text-muted font-size-12 p-0'
                                  onClick={clearAllRecentSearches}
                                  style={{ textDecoration: 'none' }}
                                >
                                  ล้างทั้งหมด
                                </button>
                              </div>
                              {recentSearches.map((phrase, idx) => (
                                <div
                                  key={idx}
                                  className='search-bar-auto-item history-item'
                                  onClick={() => {
                                    setFiltertext(phrase);
                                    begin_search('product', 'contain', null, null, phrase);
                                  }}
                                >
                                  <div className='history-text-wrap'>
                                    <i className='far fa-clock'></i>
                                    <span className='item-name'>{phrase}</span>
                                  </div>
                                  <button
                                    className='btn-remove-history'
                                    onClick={(e) => removeRecentSearch(e, phrase)}
                                  >
                                    <i className='fas fa-times'></i>
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}

                          {suggestedShops.length > 0 && (
                            <div className='search-section'>
                              <div className='search-section-title'>🏪 ร้านขายยาแนะนำ</div>
                              <div className='row no-gutters' style={{ gap: '8px' }}>
                                {suggestedShops.map((shop, idx) => (
                                  <div key={idx} className='col-12 col-md-3'>
                                    <div
                                      className='search-pill'
                                      style={{ width: '100%', borderRadius: '12px' }}
                                      onClick={() =>
                                        handleSelectOption({
                                          type: 'shop',
                                          id: shop.shop_id,
                                          name: shop.shop_name,
                                        })
                                      }
                                    >
                                      <i className='fas fa-store text-primary'></i>
                                      <div className='text-truncate' style={{ maxWidth: '140px' }}>
                                        {shop.shop_name}
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      ) : filteredShops.length === 0 && filteredProducts.length === 0 ? (
                        <div className='search-empty-state'>
                          <div className='search-empty-icon'>
                            <i className='fas fa-search'></i>
                          </div>
                          <h5 className='search-empty-title'>
                            ไม่พบสินค้าหรือร้านค้าที่ท่านต้องการค้นหา
                          </h5>
                          <p className='search-empty-desc'>
                            ขออภัยด้วยค่ะ ลองพิมพ์ข้อความใหม่หรือค้นหาโดยใช้คำแนะนำด้านล่างนี้ดูนะคะ
                          </p>
                        </div>
                      ) : (
                        <>
                          {filteredShops.length > 0 && (
                            <div className='search-section'>
                              <label className='search-section-title'>🏪 ร้านขายยา</label>
                              {filteredShops.map((shop, index) => {
                                const absIdx = getAbsoluteIndex('shop', index);
                                return (
                                  <div
                                    key={index}
                                    className={`search-bar-auto-item ${activeIndex === absIdx ? 'search-item-active' : ''}`}
                                    onClick={() =>
                                      handleSelectOption({
                                        type: 'shop',
                                        id: shop.shop_id,
                                        name: shop.shop_name,
                                      })
                                    }
                                  >
                                    <div className='item-avatar'>
                                      <i className='fas fa-store-alt'></i>
                                    </div>
                                    <div className='item-details'>
                                      <span className='item-name'>{shop.shop_name}</span>
                                    </div>
                                    <span className='item-meta'>
                                      <i className='fas fa-map-marker-alt mr-1'></i>{' '}
                                      {shop.shop_province}
                                    </span>
                                  </div>
                                );
                              })}
                            </div>
                          )}

                          {filteredProducts.length > 0 && (
                            <div className='search-section'>
                              <label className='search-section-title'>💊 สินค้า</label>
                              {filteredProducts.map((item, index) => {
                                const absIdx = getAbsoluteIndex('product', index);
                                return (
                                  <div
                                    key={index}
                                    className={`search-bar-auto-item ${activeIndex === absIdx ? 'search-item-active' : ''}`}
                                    onClick={() =>
                                      handleSelectOption({
                                        type: 'product',
                                        shopitem_id: item.shopitem_id,
                                        id: item.productitem_id,
                                        name: item.productitem_name,
                                      })
                                    }
                                  >
                                    {item.img1_key && item.productitem_id ? (
                                      <div className='item-thumbnail'>
                                        <img
                                          src={`${process.env.REACT_APP_IMAGE_URL}${item.productitem_id}/${item.productitem_id}-1-${item.img1_key}.jpg`}
                                          alt={item.productitem_name}
                                          onError={(e) => {
                                            e.currentTarget.src = require('../../assets/images/placeholder.webp');
                                          }}
                                        />
                                      </div>
                                    ) : (
                                      <div className='item-avatar'>
                                        <i className='fas fa-capsules'></i>
                                      </div>
                                    )}
                                    <div className='item-details'>
                                      <span className='item-name'>{item.productitem_name}</span>
                                      {item.productitem_inter && (
                                        <span className='item-sub'>{item.productitem_inter}</span>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                              {(props.productCatalog?.total || 0) >
                                (props.productCatalog?.products?.length || 0) && (
                                <button
                                  className='btn btn-link w-100 text-center py-2'
                                  onClick={handleLoadMore}
                                  disabled={isLoadingMore}
                                  style={{
                                    fontSize: '13px',
                                    color: '#2196F3',
                                    fontWeight: '600',
                                    borderTop: `1px solid ${colors.slate100}`,
                                    marginTop: '8px',
                                    cursor: isLoadingMore ? 'not-allowed' : 'pointer',
                                    opacity: isLoadingMore ? 0.6 : 1,
                                  }}
                                >
                                  {isLoadingMore ? (
                                    <>
                                      <i className='fas fa-spinner fa-spin mr-1'></i> กำลังโหลด...
                                    </>
                                  ) : (
                                    <>
                                      <i className='fas fa-chevron-down mr-1'></i> โหลดเพิ่มเติม (
                                      {props.productCatalog?.products?.length || 0}/
                                      {props.productCatalog?.total || 0})
                                    </>
                                  )}
                                </button>
                              )}
                            </div>
                          )}

                          {flatResults.length > 0 && (
                            <div
                              className={`search-bar-auto-item ${activeIndex === getAbsoluteIndex('all', 0) ? 'search-item-active' : ''}`}
                              style={{
                                borderTop: `1px solid ${colors.slate100}`,
                                marginTop: '4px',
                                paddingTop: '12px',
                              }}
                              onClick={() =>
                                handleSelectOption({ type: 'all', keyword: debouncedText })
                              }
                            >
                              <i className='fas fa-search text-primary'></i>
                              <span className='item-name' style={{ fontWeight: '700' }}>
                                ค้นหา "{debouncedText}" ในสินค้าทั้งหมด
                              </span>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </li>
          {props.permitdata !== null ? (
            props.permitdata.role !== 'guest' && props.permitdata.token !== '' ? (
              <>
                <li className='col d-xl-none px-1 px-sm-2'>
                  <Link
                    to={'/marketplace/mycart?cart=' + generate_token(20)}
                    className='text-dark position-relative d-flex '
                    data-toggle='tooltip'
                    data-placement='top'
                    title='ตะกร้าสินค้าของฉัน'
                  >
                    <i className='font-size-22 ec ec-add-to-cart'></i>
                    {props.mycartlen > 0 ? (
                      <span className='width-22 height-22 bg-warning position-absolute d-flex align-items-center justify-content-center rounded-circle left-12 top-8 font-weight-bold font-size-12 text-dark'>
                        {props.mycartlen}
                      </span>
                    ) : null}
                  </Link>
                </li>
                <li className='col d-xl-none pr-xl-0 px-1 px-sm-2'>
                  <Link
                    to='/myshop/buyer/payment'
                    className='text-dark position-relative d-flex'
                    data-toggle='tooltip'
                    data-placement='top'
                    title='ร้านค้าของฉัน'
                  >
                    <i className='font-size-22 ec ec-user'></i>
                    {props.myorderlen > 0 ? (
                      <span className='width-22 height-22 bg-warning position-absolute flex-content-center text-dark rounded-circle left-12 top-8 font-weight-bold font-size-12'>
                        {props.myorderlen}
                      </span>
                    ) : null}
                  </Link>
                </li>
              </>
            ) : null
          ) : null}
        </ul>
      </div>
      <ModalPopupMessage
        callback_general={(message) => {
          showDialogCallback_General(message);
        }}
        callback_confirm={(message) => {
          showDialogCallback_Confirm(message);
        }}
        options={modal_popup}
      />
    </div>
  );
}

function NavbarMobileShopee(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [filtertext, setFiltertext] = useState('');
  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const [isSearchOverlayOpen, setIsSearchOverlayOpen] = useState(false);

  const searchParams = new URLSearchParams(location.search);
  const currentCategory = searchParams.get('category') || '';

  function begin_search() {
    if (filtertext !== '') {
      navigate(
        '/marketplace?category=ค้นหาสินค้า&searchtype=contain&productid=none&detail=' + filtertext,
      );
    }
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') {
      begin_search();
    }
  }

  function generate_token(length) {
    var a = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'.split('');
    var b = [];
    for (var i = 0; i < length; i++) {
      var j = (Math.random() * (a.length - 1)).toFixed(0);
      b[i] = a[j];
    }
    return b.join('');
  }

  const cartCount = props.mycartlen || 0;
  const categories = props.systemdata_productcategorylist || [];

  return (
    <div className='d-block d-xl-none'>
      <div className='mobile-header-top-bar d-flex align-items-center justify-content-between bg-white px-3 py-2'>
        <div className='mobile-menu-trigger' onClick={() => props.callback_sidebar_toggle(true)}>
          <i className='fas fa-bars font-size-24 text-dark'></i>
        </div>
        <div className='mobile-logo-text font-th text-primary font-weight-bold font-size-20'>
          มียา.com
        </div>
        <div style={{ width: '24px' }}></div>
      </div>

      <div style={{ background: '#fff', borderBottom: '1px solid #eee' }}>
        <div className='d-flex align-items-center' style={{ padding: '8px 10px' }}>
          <div className='flex-grow-1 position-relative mr-3'>
            <input
              type='text'
              className='form-control border font-th'
              style={{
                borderRadius: '4px',
                paddingRight: '40px',
                height: '38px',
                fontSize: '14px',
                background: '#f5f5f5',
                cursor: 'pointer',
              }}
              placeholder='ค้นหาสินค้าและร้านค้า'
              value={filtertext}
              onClick={() => setIsSearchOverlayOpen(true)}
              onFocus={() => setIsSearchOverlayOpen(true)}
              readOnly={true}
            />
            <i
              className='fas fa-expand position-absolute'
              style={{
                right: '45px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#888',
                fontSize: '18px',
                cursor: 'pointer',
              }}
              onClick={() => setIsScannerOpen(true)}
            ></i>
            <i
              className='fe-search position-absolute'
              style={{
                right: '12px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: '#888',
                fontSize: '18px',
                cursor: 'pointer',
              }}
              onClick={() => setIsSearchOverlayOpen(true)}
            ></i>
          </div>

          {sessionStorage.getItem('meya-job-loggedin') !== 'true' && (
            <Link
              to={props.permitdata && props.permitdata.token && props.permitdata.token !== '-' ? '/marketplace/mycart?cart=' + generate_token(20) : '/'}
              className='text-dark position-relative'
            >
              <MdOutlineShoppingCart style={{ fontSize: '28px' }} />
              {cartCount > 0 && (
                <span
                  className='bg-warning position-absolute d-flex align-items-center justify-content-center rounded-circle'
                  style={{
                    top: '-8px',
                    right: '-8px',
                    width: '20px',
                    height: '20px',
                    fontSize: '11px',
                    color: 'black',
                    fontWeight: 'bold',
                    lineHeight: '1',
                    padding: '0',
                  }}
                >
                  {cartCount > 99 ? '99+' : cartCount}
                </span>
              )}
            </Link>
          )}
        </div>
        {isScannerOpen && (
          <BarcodeScanner
            onScanSuccess={(code) => {
              setIsScannerOpen(false);
              if (!code) return;
              const scanCode = code.trim();
              setFiltertext(scanCode);
              // On mobile, just trigger the basic search with the scanned code
              setTimeout(() => {
                begin_search();
              }, 100);
            }}
            onClose={() => setIsScannerOpen(false)}
          />
        )}

        {/* Mobile search overlay with smart recommendations */}
        <MobileSearchOverlay
          isOpen={isSearchOverlayOpen}
          onClose={() => setIsSearchOverlayOpen(false)}
          permitdata={props.permitdata}
          app_hostname={props.app_hostname}
          productCatalog={props.productCatalog}
          islogin={props.islogin}
        />

        <div className='mobile-category-scroll-container'>
          <div className='mobile-category-scroll-wrapper'>
            <Link
              to={'/marketplace?category=รวมสินค้า&transaction=' + generate_token(10)}
              className={`mobile-category-nav-item ${currentCategory === 'รวมสินค้า' || currentCategory === '' ? 'active' : ''}`}
            >
              สินค้าทั้งหมด
            </Link>
            <Link
              to={'/marketplace?category=สินค้าโปรโมชั่น&transaction=' + generate_token(10)}
              className={`mobile-category-nav-item ${currentCategory === 'สินค้าโปรโมชั่น' ? 'active' : ''}`}
            >
              สินค้าโปรโมชั่น
            </Link>
            <Link
              to={'/marketplace?category=สินค้าแนะนำ&transaction=' + generate_token(10)}
              className={`mobile-category-nav-item ${currentCategory === 'สินค้าแนะนำ' ? 'active' : ''}`}
            >
              สินค้าแนะนำ
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.productcategory_id}
                to={
                  '/marketplace?category=' +
                  cat.productcategory_name +
                  '&transaction=' +
                  generate_token(10)
                }
                className={`mobile-category-nav-item ${currentCategory === cat.productcategory_name ? 'active' : ''}`}
              >
                {cat.productcategory_name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

Navbar.propTypes = {
  callback_popup_register: PropTypes.func,
  callback_popup_signin: PropTypes.func,
};

NavbarSupport.propTypes = {
  callback_popup_register: PropTypes.func,
  callback_popup_signin: PropTypes.func,
};

export default Navbar;
